module.exports = __webpack_public_path__ + "static/img/T261030.f76f2cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/T261030.png
// module id = t1In
// module chunks = 1